<template>
    <v-col cols="12" md="12" sm="12" xs="12">
        <div style="padding:20px 10px">
            <div class="text-center">
                <v-label>Approximate monthly print/copy volume</v-label>
            </div>
            <VueSlider tooltip="always" v-model="form.copier.prints_per_month" :min="500" :max="20000" :interval="500" />
        </div>
    </v-col>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'
import VueSlider from 'vue-3-slider-component'

const store = useGlobalsStore()
const { form } = storeToRefs(store)
</script>
